module.exports = [
  { name: "signin", journey: "profile/onboarding" },
  { name: "ebook", journey: null },
  { name: "routes", journey: null },
  { name: "bookmark", journey: null },
  { name: "passthrough", journey: null },
];
